import GLOBALS from '../globals'
import { forgetSession } from './authSession'

import ACTIONS from '../actions/types'

const logoutUser = () => {
  if(GLOBALS.history) {

    forgetSession()
    GLOBALS.reduxStore.dispatch({type: ACTIONS.LOGOUT})
    GLOBALS.history.push('/ui/auth')
  }
};

export default logoutUser;
